import { render, staticRenderFns } from "./declare.vue?vue&type=template&id=44e0fd72&scoped=true&"
import script from "./declare.vue?vue&type=script&lang=js&"
export * from "./declare.vue?vue&type=script&lang=js&"
import style0 from "./declare.vue?vue&type=style&index=0&id=44e0fd72&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e0fd72",
  null
  
)

export default component.exports